import './globals.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Home from './home/Page';
import Account from './account/Page';
import Login from './login/Page';
import { UserProvider } from './context/UserDetails';
import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL


function App() {

  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/home' element={<Home />} />
          <Route path='/account' element={<Account />} />
          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
